import styled from "@emotion/styled"
import SectionWrapper from "../../components/section-wrapper/section-wrapper.component"
import { Container, Typography } from "@mui/material"

export const Section = styled(SectionWrapper)``

export const Wrapper = styled(Container)`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`

export const FaqsContainer = styled.div`
  border-radius: 40px;
  border: 1px solid rgba(128, 208, 188, 0.55);
  background: ${({ theme }) => theme.palette.secondary.light};
  width: 100%;
  padding: 100px 170px;

  ${({ theme }) => theme.breakpoints.down("md")} {
    padding: 3rem 1rem;
  }
`

export const Description = styled.div`
  max-width: 565px;
  margin-bottom: ${({ theme }) => theme.typography.pxToRem(48)};
  p,
  a {
    color: ${({ theme }) => theme.palette.primary.dark};
    text-align: center;
    font-size: ${({ theme }) => theme.typography.pxToRem(20)};
    font-style: normal;
    font-weight: 400;
    line-height: ${({ theme }) => theme.typography.pxToRem(32)};
    letter-spacing: -0.04px;
  }

  a {
    text-decoration: underline;
  }

  ${({ theme }) => theme.breakpoints.down("md")} {
    p,
    a {
      font-size: ${({ theme }) => theme.typography.pxToRem(18)};
      line-height: ${({ theme }) => theme.typography.pxToRem(30)};
    }
  }
`

export const QuestionsTitle = styled(Typography)`
  color: ${({ theme }) => theme.palette.primary.dark};
  text-align: center;
  font-size: ${({ theme }) => theme.typography.pxToRem(48)};
  font-style: normal;
  font-weight: 500;
  line-height: ${({ theme }) => theme.typography.pxToRem(48)};
  margin-bottom: ${({ theme }) => theme.typography.pxToRem(60)};

  ${({ theme }) => theme.breakpoints.down("md")} {
    font-size: ${({ theme }) => theme.typography.pxToRem(28)};
    line-height: ${({ theme }) => theme.typography.pxToRem(36)};
    margin-bottom: ${({ theme }) => theme.typography.pxToRem(28)};
  }
`
